import styled from 'styled-components';

export const DropdownItem = styled.div.attrs<{ $active?: boolean }>((props) => ({
  className: `cursor-pointer rounded px-2 py-1.5 text-sm ${
    props.$active ? 'bg-accent text-accent-foreground' : 'text-foreground'
  }`,
}))<{ $active?: boolean }>``;
